import React from "react";
import "./signaturePad.scss";

interface IProps {
  base64string: string;
  height?: number;
  width?: number;
}

export default function SignaturePreview({ base64string, height = 200, width }: IProps) {

  return <div className="ui-signature-pad-container"><img src={base64string} style={{ height, width: width ?? "auto" }} /></div>;
}